import { GetApi } from "./Api";

// params = {patient_id: int, start: string, end: string}
export const getPatientProgress = async (params) => {
  const url = `/patients/${params?.patient_id}/progress?start=${params?.start}&end=${params?.end}`;
  const result = await GetApi(url);

  return result?.data;
};

// params = {patient_id: int, start: string, end: string}
export const getPatientTimeline = async (params) => {
  const url = `/patients/${params?.patient_id}/timeline?start=${params?.start}&end=${params?.end}`;
  const result = await GetApi(url);

  return result?.data;
};

// params = {patient_id: int, day: string}
export const getPatientEvents = async (params) => {
  const url = `/patients/${params?.patient_id}/events?day=${params?.day}`;
  const result = await GetApi(url);

  return result?.data;
};

// params = {patient_id: int, event_type_id: string, graph_id: string}
export const getPatientEventGraph = async (params) => {
  const result = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/patients/${params?.patient_id}/graph`,
    {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'start': params?.start,
        'end': params?.end,
        'stat': params?.event_type_id,
      })
    },
  );

  if (result.ok) {
    return await result.json();
  } else {
    throw await result.json();
  }
};

// params = {patient_id: int, start: string, end: string}
export const getPatientEventAvailableDates = async (params) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/patients/${params?.patient_id}/events/available_dates?start=${params?.start}&end=${params?.end}`;
  const result = await GetApi(url);
  return result?.data;
};

// params = {patient_id: uuid, start: string, end: string}
export const getPatientData = async (params) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/patients/${params?.patient_id}/raw?start=${params?.start}&end=${params?.end}`;
  const result = await fetch(url, {
    credentials: 'include',
  });

  if (result.ok) {
    return await result.arrayBuffer();
  } else {
    throw await result.json();
  }
};
